import React from 'react';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import getStyles from './styles';

const faqs = [
  {
    question: 'Does the 10-days guarantee apply to e-commerce websites?',
    answer:
      'No. The 10-days guarantee applies only to standard websites (up to 5 pages, template-based). Custom sites and e-commerce require additional time.'
  },
  {
    question: "What if I don't provide content on time?",
    answer:
      "Countdown starts only after all content, images, and access credentials are received. We'll work with you to ensure everything is ready before starting the timer."
  },
  {
    question: 'Can I request design changes?',
    answer:
      "Minor adjustments are included, but extensive redesigns are outside the 10-days guarantee. We'll discuss any major changes and adjust timelines accordingly."
  },
  {
    question: 'How does the money-back guarantee work?',
    answer:
      'If we fail to make your website live within 2 days from receiving all content, you get a full refund. No questions asked.'
  },
  {
    question: 'What happens after my website goes live?',
    answer:
      "After launch, you'll have full control of your website. We offer optional maintenance packages if you need ongoing support and updates."
  }
];

const TenDaysMVPQuestions = () => {
  const styles = getStyles();

  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Typography variant="h2" sx={styles.title}>
            Frequently Asked Questions
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            Everything you need to know about our 10-days launch process
          </Typography>
        </Box>

        {/* FAQ List */}
        <Box sx={styles.accordionContainer}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              sx={{
                ...styles.accordionItem,
                animationDelay: `${index * 0.1}s`
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
                sx={styles.accordionSummary}
              >
                <Typography sx={styles.question}>{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={styles.accordionDetails}>
                <Typography sx={styles.answer}>{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default TenDaysMVPQuestions;
